import { render, staticRenderFns } from "./DiscountRow.vue?vue&type=template&id=56cc9bec&scoped=true"
import script from "./DiscountRow.vue?vue&type=script&lang=js"
export * from "./DiscountRow.vue?vue&type=script&lang=js"
import style0 from "./DiscountRow.vue?vue&type=style&index=0&id=56cc9bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc9bec",
  null
  
)

export default component.exports